import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getAccount } from '../modules/high_level_actions';

class OneTimePaymentLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email:              '',
      password:           '',
      sap_account_number: '',
      zip:                ''
    }

    this.handleChange = this.handleChange.bind(this);
    this.getAccount   = this.getAccount.bind(this);
  }

  handleChange( sType, event ) {
    let oUpdate      = {};
    oUpdate[ sType ] = event.target.value;
    this.setState( oUpdate );
  }

  getAccount(  aVal, bVal, evt ) {
    evt.preventDefault();
    let oState   = {};
    oState[aVal] = this.state[aVal];
    oState[bVal] = this.state[bVal];
    this.props.dispatch( getAccount( oState ) );
  }

  render() {
    return(
        <div className="modal-body onetime-payment-login">
          <div className={"errorMessage hidden " + (this.props.loginError ? 'showing' : '')}>
            <p>{this.props.loginError}</p>
          </div>
          <div className="half-col left">
            <form name="accountIdLogin" onSubmit={this.getAccount.bind( this, 'sap_account_number', 'zip' )} >
              <h4 className="alt">Catalog Members</h4>
              <p>If you are a catalog member and would like to make a one-time payment, enter your membership information here</p>
              <input
                onChange    = {this.handleChange.bind( this, 'sap_account_number' )}
                type        = "text"
                name        = "sap_account_number"
                placeholder = "Account Number"
                required />
              <input
                onChange    = {this.handleChange.bind( this, 'zip' )}
                type        = "text"
                name        = "zip"
                placeholder = "Zipcode"
                required />
              <button className="btn-primary full-width">Login</button>
            </form>
          </div>
          <div className="half-col right">
            <h4 className="alt">Online Members</h4>
            <p>If you have an existing online account, enter your login information here</p>
            <form className="accountPwdLogin" onSubmit={this.getAccount.bind( this, 'email', 'password' )}>
              <input
                onChange    = {this.handleChange.bind( this, 'email' )}
                type        = "email"
                value       = {this.state.email}
                placeholder = "Email Address"
                required />
              <input
                onChange    = {this.handleChange.bind( this, 'password' )}
                type        = "password"
                value       = {this.state.password}
                placeholder = "Password"
                required />
              <button className="btn-primary full-width">Login</button>
            </form>
          </div>
        </div>
    );
  }
};


function mapStateToProps(state){
    return {
      'loginError': state.loginError
    };
}

export default connect(mapStateToProps)(OneTimePaymentLogin);


// WEBPACK FOOTER //
// ./src/components/OneTimePaymentLogin.jsx